'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMacroKey = exports.applyMacros = undefined;

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

var _assign2 = require('lodash/assign');

var _assign3 = _interopRequireDefault(_assign2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _num = require('@nerdwallet/nw-client-lib/num');

var _num2 = _interopRequireDefault(_num);

var _reactCheckbox = require('@nerdwallet/react-checkbox');

var _reactCheckbox2 = _interopRequireDefault(_reactCheckbox);

var _reactHelpBubble = require('@nerdwallet/react-help-bubble');

var _reactHelpBubble2 = _interopRequireDefault(_reactHelpBubble);

var _reactFormattedInput = require('@nerdwallet/react-formatted-input');

var _reactFormattedInput2 = _interopRequireDefault(_reactFormattedInput);

var _reactInputGroup = require('@nerdwallet/react-input-group');

var _reactInputGroup2 = _interopRequireDefault(_reactInputGroup);

var _reactRadio = require('@nerdwallet/react-radio');

var _reactRadio2 = _interopRequireDefault(_reactRadio);

var _reactPercentageInput = require('@nerdwallet/react-percentage-input');

var _reactPercentageInput2 = _interopRequireDefault(_reactPercentageInput);

var _reactSelect = require('@nerdwallet/react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactTextarea = require('@nerdwallet/react-textarea');

var _reactTextarea2 = _interopRequireDefault(_reactTextarea);

var _reactStepper = require('@nerdwallet/react-stepper');

var _reactStepper2 = _interopRequireDefault(_reactStepper);

var _hasConfigMacro = require('./has-config-macro');

var _trackInputField2 = require('./track-input-field');

var _trackInputField3 = _interopRequireDefault(_trackInputField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable class-methods-use-this, react/require-default-props */


// React components


var _trackInputField = (0, _trackInputField3.default)(),
    INPUT_TYPES = _trackInputField.INPUT_TYPES,
    trackInputChange = _trackInputField.trackInputChange;

/* eslint-disable react/prop-types, react/no-danger */


var ValidationFeedback = function ValidationFeedback(_ref) {
  var feedback = _ref.feedback;
  return _react2.default.createElement(
    'span',
    null,
    feedback.map(function (string) {
      return _react2.default.createElement('span', {
        key: string,
        dangerouslySetInnerHTML: {
          __html: string
        }
      });
    })
  );
};
/* eslint-enable react/prop-types, react/no-danger */

var ConfigBuilder = function (_Component) {
  _inherits(ConfigBuilder, _Component);

  function ConfigBuilder() {
    _classCallCheck(this, ConfigBuilder);

    return _possibleConstructorReturn(this, (ConfigBuilder.__proto__ || Object.getPrototypeOf(ConfigBuilder)).apply(this, arguments));
  }

  _createClass(ConfigBuilder, [{
    key: 'onBlur',
    value: function onBlur(config, e) {
      // Track input form changes
      this.processTracking(config, e);

      // Do we have a custom onBlur?
      if (typeof this.props.onBlur === 'function') {
        this.props.onBlur(config, this.getEventValue(config, e));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(config, e) {
      // Do not track input and textarea types, these get tracked on onblur
      if (config.viewType !== 'input' && config.viewType !== 'textarea') {
        // Track input form changes
        this.processTracking(config, e);
      }

      // Do we have a custom onChange?
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(config, this.getEventValue(config, e));
      }
    }
  }, {
    key: 'getEventValue',
    value: function getEventValue(config, e) {
      switch (config.viewType) {
        case 'slider':
        case 'stepper':
          return e;
        case 'textarea':
        case 'radio':
        case 'checkbox':
        case 'select':
          return e.target.value;
        default:
          {
            var value = e.target.value;
            // eslint-disable-next-line no-nested-ternary

            return config.subType === 'text' || config.formatType === 'date' ? value : value === '' ? '' : _num2.default.value(value);
          }
      }
    }
  }, {
    key: 'getTrackingInputType',
    value: function getTrackingInputType(config) {
      switch (config.viewType) {
        case 'radio':
        case 'select':
        case 'slider':
        case 'stepper':
          return INPUT_TYPES.RANGE;
        case 'textarea':
        default:
          return INPUT_TYPES.TEXT;
      }
    }
  }, {
    key: 'getValidation',
    value: function getValidation(config, rawConfig) {
      // Is the validation config dynamically populated?
      if (typeof config.getValidationConfig === 'function') {
        // Apply the configuration returned from the function...
        return config.getValidationConfig(this.props.data, config, rawConfig);
      } else if (config.validation) {
        return {
          isValid: config.value === undefined || config.value >= config.min && config.value <= config.max
        };
      }

      return undefined;
    }
  }, {
    key: 'getValidationProps',
    value: function getValidationProps(config, rawConfig) {
      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;

      var help = void 0;
      if (feedback && feedback.length > 0) {
        help = _react2.default.createElement(ValidationFeedback, { feedback: feedback });
      }

      return {
        error: error,
        help: help
      };
    }
  }, {
    key: 'processTracking',
    value: function processTracking(config, e) {
      // Track input form changes

      if (this.props.enableTracking) {
        trackInputChange({
          fieldName: config.trackingFieldName || (0, _hasConfigMacro.getMacroKey)(config, 'value'),
          fieldValue: config.trackingRedactValue ? '' : '' + this.getEventValue(config, e),
          inputType: this.getTrackingInputType(config),
          formName: this.props.formName
        });
      }
    }
  }, {
    key: 'renderPercentageInput',
    value: function renderPercentageInput(config, rawConfig) {
      var eventConfig = (0, _assign3.default)({}, rawConfig, {
        viewType: 'percentage'
      });

      var placeholder = config.skipFormatPlaceholder || (0, _isEmpty3.default)(config.placeholder) ? config.placeholder : _num2.default.formatPercent(config.placeholder, config.formatMask);

      // values from config-builder macros are always strings
      var value = (0, _isEmpty3.default)(config.value) ? '' : _num2.default.value(config.value);

      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help = void 0;
      if (feedback && feedback.length > 0) {
        help = _react2.default.createElement(ValidationFeedback, { feedback: feedback });
      }

      var props = _extends({}, (0, _pick3.default)(config, ['autoFocus', 'formatMask', 'formatTimer', 'type']), {
        placeholder: placeholder,
        value: value,
        error: error,
        fullWidth: true,
        onBlur: this.onBlur.bind(this, eventConfig),
        onChange: this.onChange.bind(this, eventConfig),
        onFocus: this.props.onFocus,
        onKeyPress: this.props.onKeyPress
      });

      var input = _react2.default.createElement(
        'span',
        { className: 'nw-cfg-input-width' },
        _react2.default.createElement(_reactPercentageInput2.default, props)
      );

      if (config.isInline) {
        return input;
      }

      return _react2.default.createElement(_reactInputGroup2.default, {
        label: config.label,
        input: input,
        error: error,
        help: help,
        tooltip: config.help
      });
    }
  }, {
    key: 'renderInput',
    value: function renderInput(config, rawConfig) {
      var eventConfig = (0, _assign3.default)({}, rawConfig, {
        viewType: 'input'
      });

      var placeholder = config.placeholder,
          value = config.value;


      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help = void 0;
      if (feedback && feedback.length > 0) {
        help = _react2.default.createElement(ValidationFeedback, { feedback: feedback });
      }
      var props = _extends({}, (0, _pick3.default)(config, ['autoFocus', 'formatType', 'formatTriggerEvent', 'maxLength', 'type', 'skipFormatPlaceholder']), {
        placeholder: placeholder !== undefined ? placeholder : '',
        value: value !== undefined ? value : '',
        fullWidth: true,
        error: error,
        onBlur: this.onBlur.bind(this, eventConfig),
        onChange: this.onChange.bind(this, eventConfig),
        onFocus: this.props.onFocus,
        onKeyPress: this.props.onKeyPress
      });

      var input = _react2.default.createElement(
        'span',
        { className: 'nw-cfg-input-width' },
        _react2.default.createElement(_reactFormattedInput2.default, props)
      );

      if (config.isInline) {
        return input;
      }

      return _react2.default.createElement(_reactInputGroup2.default, {
        label: config.label,
        input: input,
        error: error,
        help: help,
        tooltip: config.help
      });
    }
  }, {
    key: 'renderStepper',
    value: function renderStepper(config, rawConfig) {
      var _this2 = this;

      var value = config.value;


      var props = {
        onChange: this.onChange.bind(this, (0, _assign3.default)({}, rawConfig, {
          viewType: 'stepper'
        })),
        value: _num2.default.value(value)
      };

      var input = void 0;
      if (config.subType === 'number') {
        var formatFn = (0, _isFunction3.default)(config.formatFn) ? config.formatFn : config.formatType && function (val) {
          return _num2.default['format' + (0, _startCase3.default)(config.formatType)](val);
        };

        props = (0, _assign3.default)(props, _extends({}, (0, _omit3.default)(config, ['value']), {
          formatFn: formatFn
        }));

        (0, _forEach3.default)(['min', 'max'], function (propName) {
          // If we have functions for min and max - invoke them now.
          if ((0, _isFunction3.default)(props[propName])) {
            props[propName] = props[propName](_this2.props);
          }
        });

        input = _react2.default.createElement(_reactStepper.NumStepper, props);
      } else {
        props = (0, _assign3.default)(props, _extends({}, (0, _pick3.default)(config, ['range'])));

        input = _react2.default.createElement(_reactStepper2.default, props);
      }

      return _react2.default.createElement(_reactInputGroup2.default, { label: config.label, input: input, tooltip: config.help });
    }
  }, {
    key: 'renderSelect',
    value: function renderSelect(config, rawConfig) {
      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help = void 0;
      if (feedback && feedback.length > 0) {
        help = _react2.default.createElement(ValidationFeedback, { feedback: feedback });
      }
      var props = {
        error: error,
        autoFocus: config.autoFocus,
        block: true,
        onChange: this.onChange.bind(this, (0, _assign3.default)({}, rawConfig, {
          viewType: 'select'
        })),
        options: (0, _map3.default)(rawConfig.items, function (_ref2) {
          var label = _ref2.label,
              value = _ref2.value;
          return {
            label: label,
            value: value
          };
        })
      };

      // value will block defaultValue even if its an empty string
      // TODO can this be === ''?
      // eslint-disable-next-line eqeqeq
      if (config.defaultValue && config.value == '') {
        props.defaultValue = config.defaultValue;
      } else {
        props.value = config.value;
      }

      var input = _react2.default.createElement(
        'span',
        { className: 'nw-cfg-input-width' },
        _react2.default.createElement(_reactSelect2.default, props)
      );

      return _react2.default.createElement(_reactInputGroup2.default, {
        label: config.label,
        input: input,
        error: error,
        help: help,
        tooltip: config.help
      });
    }
  }, {
    key: 'renderRadio',
    value: function renderRadio(config, rawConfig) {
      var validation = this.getValidationProps(config, rawConfig);

      var options = (0, _map3.default)(rawConfig.items, function (_ref3) {
        var label = _ref3.label,
            value = _ref3.value;
        return {
          label: label,
          value: String(value)
        };
      });

      var props = {
        defaultValue: !config.noDefaultChecked && config.defaultValue,
        inline: config.inline,
        name: config.name,
        onChange: this.onChange.bind(this, (0, _assign3.default)({}, rawConfig, {
          viewType: 'radio'
        })),
        options: options,
        value: config.value
      };

      var input = _react2.default.createElement(_reactRadio2.default, props);
      return _react2.default.createElement(_reactInputGroup2.default, {
        label: config.label,
        input: input,
        error: validation.error,
        help: validation.help,
        tooltip: config.help
      });
    }
  }, {
    key: 'renderCheckbox',
    value: function renderCheckbox(config, rawConfig) {
      var eventConfig = (0, _assign3.default)({}, rawConfig, {
        viewType: 'checkbox'
      });

      var name = config.name,
          value = config.value,
          readOnly = config.readOnly,
          disabled = config.disabled,
          defaultValue = config.defaultValue,
          inline = config.inline;
      var options = rawConfig.options;


      var props = {
        disabled: disabled,
        options: options,
        readOnly: readOnly,
        value: value,
        name: name,
        inline: inline,
        defaultValue: defaultValue,
        onChange: this.onChange.bind(this, eventConfig)
      };

      return _react2.default.createElement(_reactInputGroup2.default, {
        label: config.label,
        input: _react2.default.createElement(_reactCheckbox2.default, props),
        tooltip: config.help
      });
    }
  }, {
    key: 'renderTextarea',
    value: function renderTextarea(config, rawConfig) {
      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help = void 0;
      if (feedback && feedback.length > 0) {
        help = _react2.default.createElement(ValidationFeedback, { feedback: feedback });
      }

      var props = {
        placeholder: config.placeholder,
        value: config.value,
        fullWidth: true,
        error: error,
        onBlur: this.onBlur.bind(this, rawConfig),
        onChange: this.onChange.bind(this, rawConfig)
      };

      return _react2.default.createElement(_reactInputGroup2.default, {
        label: config.label,
        input: _react2.default.createElement(_reactTextarea2.default, props),
        error: error,
        help: help,
        tooltip: config.help
      });
    }
  }, {
    key: 'renderCustomComponent',
    value: function renderCustomComponent(config, rawConfig) {
      var CustomComponent = this.props.customComponents[rawConfig.componentName];


      var renderedComponent = CustomComponent(this.props);

      if (rawConfig.isNotInput) {
        return renderedComponent;
      }

      return _react2.default.createElement(_reactInputGroup2.default, {
        label: config.label,
        input: renderedComponent,
        tooltip: config.help
      });
    }
  }, {
    key: 'renderText',
    value: function renderText(config) {
      return _react2.default.createElement(
        'div',
        { className: 'nw-cfg-input-text' },
        config.label,
        config.help && _react2.default.createElement(_reactHelpBubble2.default, {
          id: config.key || config.label + '-label-nw-cfg-builder-bubble',
          popoverContent: config.help
        })
      );
    }
  }, {
    key: 'renderErrorMessage',
    value: function renderErrorMessage(config) {
      var errorMessage = config.getErrorMessage && config.getErrorMessage(this.props.data) || {};

      var classes = (0, _classnames2.default)('nw-cfg-builder-error', {
        open: !(0, _isEmpty3.default)(errorMessage)
      });

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'p',
          { className: 'error-title' },
          errorMessage.title
        ),
        _react2.default.createElement(
          'p',
          null,
          errorMessage.message
        )
      );
    }
  }, {
    key: 'renderContentText',
    value: function renderContentText(config) {
      return (0, _map3.default)(config.text, function (text, index) {
        return _react2.default.createElement(
          'p',
          { key: 'text' + index },
          text
        );
      });
    }
  }, {
    key: 'renderContentComponent',
    value: function renderContentComponent(config, rawConfig) {
      switch (rawConfig.viewType) {
        case 'checkbox':
          return this.renderCheckbox(config, rawConfig);
        case 'custom':
          return this.renderCustomComponent(config, rawConfig);
        case 'input':
          return this.renderInput(config, rawConfig);
        case 'radio':
          return this.renderRadio(config, rawConfig);
        case 'percentage':
          return this.renderPercentageInput(config, rawConfig);
        case 'select':
          return this.renderSelect(config, rawConfig);
        case 'stepper':
          return this.renderStepper(config, rawConfig);
        case 'textarea':
          return this.renderTextarea(config, rawConfig);
        case 'text':
          return this.renderText(config, rawConfig);
        default:
        // Do nothing.
      }

      return null;
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var _props = this.props,
          viewConfig = _props.viewConfig,
          titleClass = _props.titleClass;


      if (viewConfig.title !== undefined) {
        return _react2.default.createElement(
          'div',
          { className: titleClass + ' nw-cfg-builder-title' },
          viewConfig.title,
          viewConfig.titleHelp && _react2.default.createElement(_reactHelpBubble2.default, {
            id: titleClass + viewConfig.titleHelp,
            popoverContent: viewConfig.titleHelp
          })
        );
      }

      return null;
    }
  }, {
    key: 'renderImage',
    value: function renderImage(imgURL) {
      if (imgURL) {
        return _react2.default.createElement('img', { className: 'nw-cfg-builder-img', alt: '', src: imgURL });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          viewConfig = _props2.viewConfig;

      var config = (0, _hasConfigMacro.applyMacros)(viewConfig, this.props.data);

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('nw-cfg-builder-v6', className, viewConfig.className, viewConfig.key)
        },
        this.renderImage(viewConfig.imgURL),
        this.renderTitle(),
        this.renderContentText(config),
        this.renderContentComponent(config, viewConfig),
        this.renderErrorMessage(config, viewConfig)
      );
    }
  }]);

  return ConfigBuilder;
}(_react.Component);

ConfigBuilder.displayName = 'ConfigBuilder';
ConfigBuilder.propTypes = {
  /**
   * className to apply to root `div`
   */
  className: _propTypes2.default.string,
  /**
   * Whether to enable FORM_INPUT_CHANGED events.
   * @default true
   */
  enableTracking: _propTypes2.default.bool,
  /**
   * formName supplied to FORM_INPUT_CHANGED
   * @default 'config-builder'
   */
  formName: _propTypes2.default.string,
  /**
   * Called when input loses focus, receives `viewConfig, eventValue`
   */
  onBlur: _propTypes2.default.func,
  /**
   * Called when an input changes, receives `viewConfig, eventValue`
   */
  onChange: _propTypes2.default.func,
  /**
   * Called when input gains focus, receives `event`
   */
  onFocus: _propTypes2.default.func,
  /**
   * Invoked onKeyPress of component, receives `event`
   */
  onKeyPress: _propTypes2.default.func,
  /**
   * Object of references to custom components, key should match `componentName`
   * in `viewConfig`
   */
  customComponents: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Arbitrary object of data that is passed to various callbacks
   */
  data: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * className to apply to `title`
   */
  titleClass: _propTypes2.default.string,
  /**
   * The config for the underlying component
   */
  viewConfig: _propTypes2.default.shape({
    // All components
    viewType: _propTypes2.default.oneOf(['checkbox', 'custom', 'input', 'percentage', 'radio', 'select', 'stepper', 'text', 'textarea']).isRequired,
    /**
     * Arbitrary text inserted above the input component, wrapped around a `<p>`.
     */
    text: _propTypes2.default.arrayOf(_propTypes2.default.node),
    /**
     * Arbitrary text inserted above the input component, wrapped around a `<div>`.
     * @deprecated
     */
    title: _propTypes2.default.string,
    /**
     * Arbitrary text passed along to `<HelpBubble>`.
     * @deprecated
     */
    titleHelp: _propTypes2.default.string,
    /**
     * Stepper only. Either `'number'` or not.
     */
    subType: _propTypes2.default.string,
    /**
     * fieldName of FORM_INPUT_CHANGED
     */
    trackingFieldName: _propTypes2.default.string,
    /**
     * Redacts field value from FORM_INPUT_CHANGED if true
     */
    trackingRedactValue: _propTypes2.default.bool,
    /**
     * Specify options for Radios, Checkboxes, Select
     */
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      label: _propTypes2.default.string.isRequired,
      value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired
    })),
    /**
     * Used for non-number stepper
     */
    range: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired,
      value: _propTypes2.default.string.isRequired
    })),
    /**
     * Specify options for Radio, Select
     */
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      label: _propTypes2.default.string.isRequired,
      value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired
    })),
    /**
     * Renders a HelpBubble. Passed to `InputGroup` as `tooltip`.
     */
    help: _propTypes2.default.string,
    /**
     * The label of an input.  Consider this required if this renders an input.
     */
    label: _propTypes2.default.string,
    /**
     * URL of an image to insert above input
     */
    imgURL: _propTypes2.default.string,
    /**
     * For `viewType=custom` components, the name of the component as
     * defined by `props.customComponents`
     */
    componentName: _propTypes2.default.string,
    /**
     * Arbitrary object that won't be passed to component
     * Useful for passing data to an `onChange` for instance.
     */
    config: _propTypes2.default.object,
    /**
     * Callback for specifying an error message, should return an object
     * with a signature of `{ title: String, message: String }`
     * Receives `props.data` as sole argument
     * @deprecated
     */
    getErrorMessage: _propTypes2.default.func,
    /**
     * Callback for specifying an error message, should return an object
     * with a signature of `{ isValid: Boolean, feedback: [String] }`
     * Receives `props.data, config, rawConfig` as arguments
     */
    getValidationConfig: _propTypes2.default.func,
    /**
     * Legacy method of validation, if truthy, checks `value` against `undefined`
     * and `min` and `max` props.
     * Will not work if `min` and `max` are functions
     * @deprecated
     */
    validation: _propTypes2.default.bool,
    /**
     * Minimum value, only used for `NumStepper` and legacy validation
     */
    min: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
    /**
     * Maximum value, only used for `NumStepper` and legacy validation
     */
    max: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
    /**
     * "Macro" keys.
     */
    keys: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      /**
       * Defines the path to the desired value
       * `_.get(props.data, props.viewConfig.key)`
       */
      key: _propTypes2.default.string,
      /**
       * Optionally pass in all of `data` to this function instead of specifying a key
       */
      getValue: _propTypes2.default.func,
      /**
       * Optionally run through either formatCurrency or formatPercent from
       * @nerdwallet/nw-client-lib/num
       */
      type: _propTypes2.default.oneOf(['currency', 'percent']),
      /**
       * If currency, this means should include cents, if percent, defines
       * the "formatterString" as passed to `numeral` library
       */
      formatterStr: _propTypes2.default.string
    }))
  })
};
ConfigBuilder.defaultProps = {
  customComponents: {},
  enableTracking: true,
  formName: 'config-builder'
};
exports.default = ConfigBuilder;
exports.applyMacros = _hasConfigMacro.applyMacros;
exports.getMacroKey = _hasConfigMacro.getMacroKey;
ConfigBuilder.__docgenInfo = {
  'description': '',
  'displayName': 'ConfigBuilder',
  'props': {
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'className to apply to root `div`'
    },
    'enableTracking': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether to enable FORM_INPUT_CHANGED events.\n@default true',
      'defaultValue': {
        'value': 'true',
        'computed': false
      }
    },
    'formName': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'formName supplied to FORM_INPUT_CHANGED\n@default \'config-builder\'',
      'defaultValue': {
        'value': '\'config-builder\'',
        'computed': false
      }
    },
    'onBlur': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Called when input loses focus, receives `viewConfig, eventValue`'
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Called when an input changes, receives `viewConfig, eventValue`'
    },
    'onFocus': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Called when input gains focus, receives `event`'
    },
    'onKeyPress': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Invoked onKeyPress of component, receives `event`'
    },
    'customComponents': {
      'type': {
        'name': 'object'
      },
      'required': false,
      'description': 'Object of references to custom components, key should match `componentName`\nin `viewConfig`',
      'defaultValue': {
        'value': '{}',
        'computed': false
      }
    },
    'data': {
      'type': {
        'name': 'object'
      },
      'required': false,
      'description': 'Arbitrary object of data that is passed to various callbacks'
    },
    'titleClass': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'className to apply to `title`'
    },
    'viewConfig': {
      'type': {
        'name': 'shape',
        'value': {
          'viewType': {
            'name': 'enum',
            'value': [{
              'value': '\'checkbox\'',
              'computed': false
            }, {
              'value': '\'custom\'',
              'computed': false
            }, {
              'value': '\'input\'',
              'computed': false
            }, {
              'value': '\'percentage\'',
              'computed': false
            }, {
              'value': '\'radio\'',
              'computed': false
            }, {
              'value': '\'select\'',
              'computed': false
            }, {
              'value': '\'stepper\'',
              'computed': false
            }, {
              'value': '\'text\'',
              'computed': false
            }, {
              'value': '\'textarea\'',
              'computed': false
            }],
            'required': true
          },
          'text': {
            'name': 'arrayOf',
            'value': {
              'name': 'node'
            },
            'description': 'Arbitrary text inserted above the input component, wrapped around a `<p>`.',
            'required': false
          },
          'title': {
            'name': 'string',
            'description': 'Arbitrary text inserted above the input component, wrapped around a `<div>`.\n@deprecated',
            'required': false
          },
          'titleHelp': {
            'name': 'string',
            'description': 'Arbitrary text passed along to `<HelpBubble>`.\n@deprecated',
            'required': false
          },
          'subType': {
            'name': 'string',
            'description': 'Stepper only. Either `\'number\'` or not.',
            'required': false
          },
          'trackingFieldName': {
            'name': 'string',
            'description': 'fieldName of FORM_INPUT_CHANGED',
            'required': false
          },
          'trackingRedactValue': {
            'name': 'bool',
            'description': 'Redacts field value from FORM_INPUT_CHANGED if true',
            'required': false
          },
          'options': {
            'name': 'arrayOf',
            'value': {
              'name': 'shape',
              'value': {
                'label': {
                  'name': 'string',
                  'required': true
                },
                'value': {
                  'name': 'union',
                  'value': [{
                    'name': 'string'
                  }, {
                    'name': 'number'
                  }, {
                    'name': 'bool'
                  }],
                  'required': true
                }
              }
            },
            'description': 'Specify options for Radios, Checkboxes, Select',
            'required': false
          },
          'range': {
            'name': 'arrayOf',
            'value': {
              'name': 'shape',
              'value': {
                'name': {
                  'name': 'string',
                  'required': true
                },
                'value': {
                  'name': 'string',
                  'required': true
                }
              }
            },
            'description': 'Used for non-number stepper',
            'required': false
          },
          'items': {
            'name': 'arrayOf',
            'value': {
              'name': 'shape',
              'value': {
                'label': {
                  'name': 'string',
                  'required': true
                },
                'value': {
                  'name': 'union',
                  'value': [{
                    'name': 'string'
                  }, {
                    'name': 'number'
                  }, {
                    'name': 'bool'
                  }],
                  'required': true
                }
              }
            },
            'description': 'Specify options for Radio, Select',
            'required': false
          },
          'help': {
            'name': 'string',
            'description': 'Renders a HelpBubble. Passed to `InputGroup` as `tooltip`.',
            'required': false
          },
          'label': {
            'name': 'string',
            'description': 'The label of an input.  Consider this required if this renders an input.',
            'required': false
          },
          'imgURL': {
            'name': 'string',
            'description': 'URL of an image to insert above input',
            'required': false
          },
          'componentName': {
            'name': 'string',
            'description': 'For `viewType=custom` components, the name of the component as\ndefined by `props.customComponents`',
            'required': false
          },
          'config': {
            'name': 'object',
            'description': 'Arbitrary object that won\'t be passed to component\nUseful for passing data to an `onChange` for instance.',
            'required': false
          },
          'getErrorMessage': {
            'name': 'func',
            'description': 'Callback for specifying an error message, should return an object\nwith a signature of `{ title: String, message: String }`\nReceives `props.data` as sole argument\n@deprecated',
            'required': false
          },
          'getValidationConfig': {
            'name': 'func',
            'description': 'Callback for specifying an error message, should return an object\nwith a signature of `{ isValid: Boolean, feedback: [String] }`\nReceives `props.data, config, rawConfig` as arguments',
            'required': false
          },
          'validation': {
            'name': 'bool',
            'description': 'Legacy method of validation, if truthy, checks `value` against `undefined`\nand `min` and `max` props.\nWill not work if `min` and `max` are functions\n@deprecated',
            'required': false
          },
          'min': {
            'name': 'union',
            'value': [{
              'name': 'number'
            }, {
              'name': 'func'
            }],
            'description': 'Minimum value, only used for `NumStepper` and legacy validation',
            'required': false
          },
          'max': {
            'name': 'union',
            'value': [{
              'name': 'number'
            }, {
              'name': 'func'
            }],
            'description': 'Maximum value, only used for `NumStepper` and legacy validation',
            'required': false
          },
          'keys': {
            'name': 'arrayOf',
            'value': {
              'name': 'shape',
              'value': {
                'key': {
                  'name': 'string',
                  'description': 'Defines the path to the desired value\n`_.get(props.data, props.viewConfig.key)`',
                  'required': false
                },
                'getValue': {
                  'name': 'func',
                  'description': 'Optionally pass in all of `data` to this function instead of specifying a key',
                  'required': false
                },
                'type': {
                  'name': 'enum',
                  'value': [{
                    'value': '\'currency\'',
                    'computed': false
                  }, {
                    'value': '\'percent\'',
                    'computed': false
                  }],
                  'description': 'Optionally run through either formatCurrency or formatPercent from\n@nerdwallet/nw-client-lib/num',
                  'required': false
                },
                'formatterStr': {
                  'name': 'string',
                  'description': 'If currency, this means should include cents, if percent, defines\nthe "formatterString" as passed to `numeral` library',
                  'required': false
                }
              }
            },
            'description': '"Macro" keys.',
            'required': false
          }
        }
      },
      'required': false,
      'description': 'The config for the underlying component'
    }
  }
};